//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getNewEmail, sendEmail, coaReport } from "@/api/index";

export default {
  mounted() {
    this.$vux.loading.show({
      text: "加载中..."
    });
    //上个页面传过来的COA报告接口的参数
    let t = this,
      barcode = t.$route.query.barcode,
      iccBatchNo = t.$route.query.iccBatchNo,
      deliveryNumber = t.$route.query.deliveryNumber,
      enterstatu = t.$route.query.enterstatu;
    t.fromtype = t.$route.query.fromtype;
    //获取COA报告接口数据
    coaReport({
      barcode,
      iccBatchNo,
      deliveryNumber,
      enterstatu
    }).then(res => {
      this.$vux.loading.hide();
      t.coaDetailDto = res.data.data.coaDetailDto;
      console.log(t.coaDetailDto);
      if (res.data.code === 0) {
        t.seal = res.data.data.coaDetailDto.seal;
        let specOrType = t.coaDetailDto.specOrType,
          specOrTypeOne = specOrType.indexOf("普通标气"),
          specOrTypeTwo = specOrType.indexOf("特殊标气");
        if (specOrTypeOne != -1 || specOrTypeTwo != -1) {
          t.specOrType = true;
        }
        if (t.coaDetailDto.coaProjectDtos[0].uclainty === undefined) {
          t.uclainty = false;
        }
      } else {
        t.$vux.toast.text(
          res.data.msg + "详情请联系林德服务中心400-820-1798",
          "middle"
        );
      }
    });
    //判断邮箱是获取的最新邮箱还是手动选择的邮箱
    if (!this.email) {
      //最新邮箱
      getNewEmail().then(res => {
        if (res.data.code === 0) {
          t.emailAddress = res.data.data.email.emailAddress;
        } else {
          t.$vux.toast.text(res.data.msg, "middle");
        }
      });
    } else {
      //用户手动选择的邮箱
      this.emailAddress = this.email.emailAddress;
    }
  },
  data() {
    return {
      coaDetailDto: null,
      emailAddress: "填写邮箱",
      seal: "",
      subjectBody: "",
      specOrType: false,
      uclainty: true,
      fromtype: 1
    };
  },
  computed: {
    //用户选择的邮箱
    email() {
      return this.$store.state.email;
    }
  },
  methods: {
    //选择其他邮箱
    selectEmail() {
      let t = this;
      t.$router.push("/selectEmail");
    },
    //发送邮件并重新扫码
    sendEmail() {
      let t = this,
        deliveryNumber = t.$route.query.deliveryNumber,
        enterstatu = t.$route.query.enterstatu,
        barcode = t.coaDetailDto.iccBarcode,
        iccBatchNo = t.coaDetailDto.batchNo,
        htmlBody = escape(
          "https://ecoa2.lindemobile.cn/pc/#/pc/analysisEmail?barcode=" +
            barcode +
            "&iccBatchNo=" +
            iccBatchNo +
            "&deliveryNumber=" +
            deliveryNumber +
            "&enterstatu=" +
            enterstatu
        );
      if (enterstatu === 0) {
        let orderId = sessionStorage.getItem("coaaOrderId");
        t.subjectBody = "林德产品分析报告-" + orderId + "-" + barcode;
      } else {
        let orderTime = sessionStorage.getItem("coaaOrderTime"),
          orderId = sessionStorage.getItem("coaaOrderId");
        t.subjectBody = "林德产品分析报告-" + orderId + "-" + orderTime;
      }
      sendEmail({
        htmlBody,
        address: t.emailAddress,
        subjectBody: t.subjectBody
      }).then(res => {
        if (res.data.code === 0) {
          t.$vux.toast.text("发送成功", "middle");
          setTimeout(() => {
            let id = t.$route.query.deliveryNumber;
            if (t.fromtype == 2) {
              t.$router.push({
                path: "/barCode",
                query: {
                  deliveryNumber: id
                }
              });
            } else {
              t.$router.push("/analysis");
            }
          }, 2000);
        } else {
          t.$vux.toast.text(res.data.msg, "middle");
        }
      });
    },
    //继续扫描
    continueScan() {
      let t = this;
      let id = t.$route.query.deliveryNumber;
      console.log(id, 9999999999);
      if (t.fromtype == 2) {
        t.$router.push({
          path: "/barCode",
          query: {
            deliveryNumber: id
          }
        });
      } else {
        t.$router.push("/analysis");
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/COA/analysisDetail.vue